import "core-js/modules/es.object.define-property";
import { __decorate, __extends } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PopupComponent from '@/components/messageBox/popup';
import { dateFormat, dateNow } from '@/lib/utils';
import store from '@/store';
import router from '@/router';
import { ROUTE_NAME, datePopup } from '@/lib/constant'; // 倒计时弹窗

var CountdownPopup =
/** @class */
function (_super) {
  __extends(CountdownPopup, _super);

  function CountdownPopup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(CountdownPopup.prototype, "countdownImage", {
    /** 倒计时显示的弹窗图片内容 */
    get: function get() {
      var key = dateFormat(dateNow());
      return datePopup[key];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CountdownPopup.prototype, "activityId", {
    /** 活动id */
    get: function get() {
      return store.getters['activity/activityId'];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CountdownPopup.prototype, "activityDetail", {
    get: function get() {
      return store.state.activity.basicInfo[this.activityId];
    },
    enumerable: false,
    configurable: true
  });

  CountdownPopup.prototype.onClickClose = function () {
    this.value = false;
  };
  /**
   * 营销活动弹窗按钮
   */


  CountdownPopup.prototype.onClickMarket = function () {
    this.value = false;
    router.push({
      name: ROUTE_NAME.ACTIVITY_SUBMIT_ORDER,
      params: {
        activityId: this.activityId
      }
    });
  };

  CountdownPopup = __decorate([Component({
    name: 'CountdownPopup',
    template: "<MyPopup v-if=\"value\" v-model=\"value\" class=\"countdown-popup\" :content-class=\"['center-popup']\" position=\"center\" :modal=\"true\">\n        <div class=\"icon-wrap\">\n            <i class=\"icon\" @click=\"onClickClose\">&#xe60b;</i>\n        </div>\n        <img class=\"image\" v-thumbnail=\"countdownImage\" />\n        <div v-if=\"activityDetail && !activityDetail.joined && activityDetail.startParticipation\" class=\"btn-wrap\">\n            <MobileButton name=\"yellow-gradient\"\n                class=\"btn-large btn-round\"\n                @click=\"onClickMarket\">\n                \u53BB\u62A5\u540D\n            </MobileButton>\n        </div>\n    </MyPopup>"
  })], CountdownPopup);
  return CountdownPopup;
}(Mixins(PopupComponent));

export { CountdownPopup };